import { useForm } from 'react-hook-form';
import '../../../../../../assets/styles/Tables.scss';
import { useEffect, useState } from 'react';

function ModalEditInput({ name, value, setValue, arrayValues, label }) {
	const { register } = useForm();

	// Значение в инпут
	useEffect(() => {
		if (arrayValues) {
			if (arrayValues.every((element) => element === arrayValues[0])) {
				setValue(arrayValues[0]);
			} else {
				setValue('Разное');
			}
		}
	}, []);

	return (
		<div className="editSelect">
			<label className="editSelect__label">{label}</label>
			<div>
				<input
					{...register(name, {
						onChange: (e) => setValue(e.target.value),
					})}
					value={value ? value : ''}
					placeholder="Введите текст"
				/>
			</div>
		</div>
	);
}

export default ModalEditInput;
